import BookReviewFeed from './BookReviewFeed';
import { NavLink } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { Seo } from 'widgets/Seo';
import logo from 'Logo.png';


function BookReviewPage() {
  const { user, isAuthenticated } = useAuth0();
  let canSubmit = false;
  if (isAuthenticated) {
    if (user && user['peloestudo/roles'].includes('Admin')) {
      canSubmit = true
    }
  }
  return (
    <>
      <Seo
        title={`${process.env.REACT_APP_SITE_TITLE} | Resenhas`}
        description='Lista de resenhas'
        type="website"
        name="Pelo Estudo e Pela F&eacute;"
        image={logo}
      />
      <h2>Resenhas</h2>
      <BookReviewFeed />
      {canSubmit &&
        <NavLink to="submit">
          Envie sua resenha aqui
        </NavLink>
      }
    </>);

}

export default BookReviewPage;